module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main about"
  }, [_c('div', {
    staticClass: "banner"
  }), _vm._v(" "), _c('div', {
    staticClass: "mainContent"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'aboutus')
      }
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'location')
      }
    }
  }, [_vm._v("Location")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'contactus')
      }
    }
  }, [_vm._v("Contact Us")])])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "aboutus",
    attrs: {
      "id": "aboutus"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Team Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\"Crait Team is headquartered in Chicago, Illinois. Crait Team dedicates to providing the safest mobile communication service to various companies, NGO, organizations and groups.  Crait is built to provide efficiency and security for your work.We will continue to offer a number of new features. With those features, Crait will provide more efficiency and security for your organiztions. \"")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "location",
      "content": "location"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Location")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/about_map@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contactus",
    attrs: {
      "id": "contactus"
    }
  }, [_c('div', {
    staticClass: "americanAddress"
  }, [_c('h3', [_vm._v("Contact Us")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("E-mail：info@craitapp.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6542d90d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 297
// module chunks = 1